import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class LanguageService {

  public languages: string[] = ['en', 'he', 'es', 'de', 'it', 'ru', 'pt'];

  constructor(public translate: TranslateService, private cookieService: CookieService) {

    let browserLang: any;
    /***
     * cookie Language Get
    */
    this.translate.addLangs(this.languages);
    if (this.cookieService.check('lang')) {
      browserLang = this.cookieService.get('lang');
    }
    else {
      browserLang = translate.getBrowserLang();
    }
    translate.use(browserLang.match(/en|es|de|it|ru|pt/) ? browserLang : 'en');
  }

  /***
   * Cookie Language set
   */
  public setLanguage(lang: string) {
    this.translate.use(lang);
    this.cookieService.set('lang', lang);
  }

	listLang() {
		const list = [
			{ text: 'English', flag: 'assets/images/flags/us.svg', lang: 'en' },
			{ text: 'עברית', flag: 'assets/images/flags/il.svg', lang: 'he' },
			{ text: 'Portuguese', flag: 'assets/images/flags/pt.svg', lang: 'pt' }
		];

		return list;
	}

}
